module.exports = new __parcel__URL__("recruitment_ja.ce317c32.webp").toString();